import {useUpdateUserNotificationPreferencesMutation} from "@/api/userApi";
import Toggle from "@/components/Common/forms/Toggle";
import ScopeAvatar from "@/components/Settings/ScopeAvatar";
import type {NotificationPreferenceListSerializer} from "@/generated/DjangoTypes";
import {capturePostHogEvent, PostHogEvents} from "@/posthog";
import type {FC} from "react";

const NotificationPreferenceRow: FC<{preference: NotificationPreferenceListSerializer; userId: number}> = ({
  preference,
  userId,
}) => {
  const isInitiallyEnabled = preference.email_enabled ?? false;
  const {mutate: updatePreference, isPending} = useUpdateUserNotificationPreferencesMutation({
    companyId: preference.company_profile.id,
    isInitiallyEnabled,
    userId,
  });

  return (
    <div className="flex items-center justify-between gap-6">
      <div className="flex min-w-0 items-center gap-3">
        <ScopeAvatar
          className="size-8 rounded-full"
          name={preference.company_profile.company_name ?? ""}
          picture={preference.company_profile.picture320 ?? null}
        />
        <span className="text-neutral-black truncate text-sm">{preference.company_profile.company_name}</span>
      </div>
      <Toggle
        checked={isInitiallyEnabled}
        disabled={isPending}
        onChange={() => {
          capturePostHogEvent(PostHogEvents.NotificationPreferenceChanged, {enabled: !isInitiallyEnabled});
          updatePreference();
        }}
      />
    </div>
  );
};

export default NotificationPreferenceRow;
